<template>
  <v-btn :to="to" elevation="0" :class="{ disabled }" class="action-btn">
    <template v-if="iconSrc" #prepend>
      <div class="action-btn__icon">
        <e-icon :src="iconSrc" size="24" />
      </div>
    </template>
    <div class="action-btn__content">
      <slot name="item" :item="item">
        {{ title }}
      </slot>
      <v-spacer />
      <e-icon name="chevronRight" :size="14" :class="disabled ? 'text-inactive' : 'text-secondary'" />
    </div>
  </v-btn>
</template>

<script setup lang="ts" generic="T">
import type { RouteLocationRaw } from 'vue-router';
import { EIcon } from '@/core/components/ui';

defineProps<{
  iconSrc?: object;
  title: string;
  to?: RouteLocationRaw;
  disabled?: boolean;
  item?: T;
}>();

defineSlots<{
  item?: (props: { item: T | undefined }) => void;
}>();
</script>

<style scoped lang="scss">
.action-btn {
  justify-content: unset;

  width: 100%;
  height: auto;
  min-height: 64px;
  padding: 8px 18px;

  word-break: break-word;

  --v-hover-opacity: 0;

  &.disabled {
    color: $text-inactive-color;

    pointer-events: none;

    .auth-action-btn__arrow {
      color: $text-inactive-color;
    }

    .auth-action-btn__icon {
      opacity: 0.3;
    }
  }

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 10px;

    background-color: $primary-light-color;
    border-radius: $border-radius;
  }

  &__content {
    display: flex;
    align-items: center;

    width: 100%;

    text-align: left;
    white-space: normal;
  }

  @include hover {
    background-color: $primary-light-color;
  }

  @include xs {
    &__content {
      font-size: 14px;
    }
  }
}
</style>
